import { ReactNode, useRef, useState } from "react";

import cn from "classnames";
import { createPortal } from "react-dom";

import { Text } from "../Text";

import styles from "./Tooltip.module.scss";

interface TooltipProps {
  containerClassName?: string;
  children?: ReactNode;
  title?: ReactNode | string;
}

interface TooltipPosition {
  top: number;
  left: number;
}

const TOOLTIP_OFFSET = 5;

export const Tooltip = (props: TooltipProps) => {
  const { containerClassName, children, title } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition | null>(null);

  const isStringTitle = typeof title === "string";

  const containerClasses = cn(styles.container, containerClassName);

  const tooltipClasses = cn(styles.tooltip);

  const tooltipText = isStringTitle ? (
    <Text alignment="center" variant="text-3-regular">
      {title}
    </Text>
  ) : (
    title
  );

  const handleMouseEnter = () => {
    if (!title || !containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();

    setTooltipPosition({
      top: containerRect.bottom + TOOLTIP_OFFSET,
      left: containerRect.left + containerRect.width / 2,
    });
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        ref={containerRef}
        className={containerClasses}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {title &&
        isVisible &&
        tooltipPosition &&
        createPortal(
          <div
            className={tooltipClasses}
            style={tooltipPosition}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {tooltipText}
          </div>,
          document.body
        )}
    </>
  );
};
